import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { BreadCrumb, SnackSimple } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../utils/icons"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { useStyles } from "./styles"
import { LoadingButton } from "@mui/lab"
import { Category } from "./components/category"
import CrudModal from "../../../../../../components/modal/crudModal"
import { DinamicForm } from "../../../../../../components/dinamicForm"

import { useBody } from "./body"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import ConfirmModal from "./components/confirmModal"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import Loader from "../../../../../../components/loader"


const DetailCatalog = () => {
  const styles = useStyles()
  const { t } = useTranslation()
  const body = useBody()
  const noSubServices = body.services.length == 0;

  return (<>
    <Box sx={styles.container}>
      {body.loading?.table && <Loader />}
      {!body.loading?.table && (
        <Box sx={styles.subContainer}>

          <BreadCrumb
              removeBreadcrumb={['report-folio']}
              replaceLabels={{ editEdit: 'editCatalog', create: 'createCatalog' }}
          />

          <FiltersDrawer cleanFilter={body.paginationMain.cleanFilter} count={body.paginationMain.counter} right={0} top={0}>
            <Box sx={styles.section}>
              <DinamicForm errors={body.paginationMain.errors} input={Object.values(body.inputFilter)} values={body.paginationMain.filterData} onChange={body.paginationMain.onChange} filter={true} legacyErrors />
            </Box>
          </FiltersDrawer>

          <Box sx={styles.header}>
            <Box sx={styles.headerInput}>
                <Typography variant="blue_title" sx={styles.title}>{t(`catalog.form.${!!body.id ? 'updateTitle' : 'createTitle'}`)}</Typography>
                <DinamicForm input={Object.values(body.inputCrud)} onChange={body.onChangeCrud} values={body.dataCrud} />
            </Box>

            <Box sx={styles.flex}>

              {!!body.paginationMain.counter && <IconButton
                sx={(styles.clean, (body.paginationMain.counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  body.paginationMain.cleanFilter()
                }}
              >
                {icons('clean')}
              </IconButton>
              }
              <Tooltip title={t('ToolTips.create')}>
                <IconButton
                  sx={styles.add}
                  onClick={() => {
                    body.handleOpenModal()
                  }}
                >
                  {icons('add')}
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <CustomPaper sx={styles.customPaper} elevation={1}>

            <Typography sx={styles.titleContainer}>{t('catalog.servicesCatalog')}</Typography>

            { noSubServices && (
                <IconButton
                  sx={styles.addService}
                  onClick={() => {
                    body.handleOpenModal()
                  }}
                >
                  {icons('add-outlined')} <Typography>{t('catalog.button.addService')}</Typography>
                </IconButton>
              )
            }

            <Box className="pd-3" sx={styles.containerChildren(noSubServices)}>
              { /* !!servicesList &&  */ body.services.filter(service => (body.normalizeString(service.name).includes(body.normalizeString(body.paginationMain.filterData.search ?? "")))).map(service =>(
                <Category key={service.id} providers={body.items} title={service.name} childs={service.subcategories} id={service.id} handleOpenModal={body.handleOpenModal} handleOpenModalDelete={body.handleOpenModalDelete}/>
              ))}
            </Box>

            <Box sx={styles.containerSaveButton}>
              <LoadingButton 
                disabled={body.disableCrudForm || body.newCatalog() } 
                loading={body.loading?.createOrUpdate} 
                onClick={()=>{body.createOrUpdate()}} 
                className="round-0" 
                variant="contained"
              >
                {t('general.saveChanges')}
              </LoadingButton>
            </Box>

            <CrudModal
              disable={body.disableCategoryForm}
              sx={styles.crudModal}
              open={body.openModal?.open ?? false}
              close={() => { if (body.openModal?.cancel) { body.openModal?.cancel() } }}
              title={body.openModal?.title ?? ""}
              buttonText={t('catalog.button.save')}
              children={<>
                <DinamicForm input={Object.values(body.input)} onChange={body.onChange} values={body.data} />
              </>}
              next={body.handleConfirm}
            />
            <SimpleModal
              open={body.openModalDelete?.open ?? false}
              close={() => {
                if (body.openModalDelete?.cancel) {
                  body.openModalDelete.cancel()
                }else{
                  body.closeModalDelete()
                }
              }}
              title={body.openModalDelete?.title}
              description={body.openModalDelete?.description}
              buttonText={t('general.confirm')}
              cancelText={t('general.cancel')}
              back={() => {
                body.openModalDelete?.cancel?.();
              }}
              next={() => {
                if (body.openModalDelete?.confirm) {
                  body.openModalDelete.confirm()
                }
              }}
            />
            
            <SimpleModal
              open={body.openModalConfirm?.open ?? false}
              close={() => {
                body.closeModalConfirm()
              }}
              title={body.openModalConfirm?.title ?? ""}
              description={body.openModalDelete?.description}
              buttonText={t('general.confirm')}
              children={<Typography sx={styles.icon}>{icons('check-outlined')}</Typography>}
              next={() => {
                body.closeModalConfirm()
              }}
            />

            <SnackSimple
              close={body.closeSnackbar}
              open={body.snackbar?.open}
              type={body.snackbar?.type}
              message={body.snackbar?.message}
            />
          </CustomPaper>

        </Box>
      )}
    </Box>
  </>
  )
}

export { DetailCatalog }
